import React from 'react';
import { Button, Form, Label, Input } from 'reactstrap';
import { Field, Fields, reduxForm } from 'redux-form';
import MaterialIcon from 'material-icons-react';
import numeral from 'numeral';
import cx from 'classnames';

// components
import { OPTIONS as CITIES } from '../../components/form/filter/city-filter';
import { OPTIONS as PRICES } from '../../components/form/filter/price-filter';
import { OPTIONS as BUILDING_TYPES } from '../../components/form/filter/building-type-filter';

// modules
import styles from '../Containers.module.scss';
import BS from '../../theme/Bootstrap';

let PriceFields = fields => {
  const { minPrice, maxPrice, tabIndex } = fields;
  const options = PRICES.residential;
  const maxPriceOptions = options.slice(
    minPrice.input.value ? options.indexOf(parseInt(minPrice.input.value, 10)) : 0
  );

  return (
    <React.Fragment>
      <Label for="minPrice">My budget is</Label>
      <Input
        name="minPrice"
        type="select"
        className={styles.madLibControl}
        {...minPrice.input}
        tabIndex={tabIndex}
      >
        {options.map(value => {
          let label =
            value > 1000000
              ? numeral(value).format('$0.00a')
              : numeral(value).format('$0a');

          if (value === 5000000) {
            label = '5+m';
          }

          return (
            <option key={value} value={value}>
              {label}
            </option>
          );
        })}
      </Input>
      <Label for="maxPrice">to</Label>
      <Input
        name="maxPrice"
        type="select"
        className={styles.madLibControl}
        {...maxPrice.input}
        tabIndex={tabIndex ? tabIndex + 1 : tabIndex}
      >
        {maxPriceOptions.map(value => {
          let label = numeral(value).format('$0a');

          if (value === 5000000) {
            label = '5+m';
          }

          return (
            <option key={value} value={value}>
              {label}
            </option>
          );
        })}
      </Input>
    </React.Fragment>
  );
};

let BuildingTypeField = field => {
  return (
    <Input {...field.input} type="select" className={styles.madLibControl}>
      {BUILDING_TYPES.residential.map(option => {
        const label = option && option.label !== undefined ? option.label : option;
        const value = option && option.value !== undefined ? option.value : option;

        return (
          <option key={value} value={value}>
            {label === 'Any' ? 'Any Home' : label}
          </option>
        );
      })}
    </Input>
  );
};

let LocationField = field => {
  const LOCATIONS = CITIES.slice(1);
  return (
    <Input
      {...field.input}
      type="select"
      className={cx(field.className, styles.madLibControl)}
    >
      {LOCATIONS.map((location, i) => {
        return (
          <option key={i} value={location.value || location}>
            {location.label || location}
          </option>
        );
      })}
    </Input>
  );
};

let BedField = field => {
  const BEDS = [
    {
      label: 'Any Beds',
      value: ''
    },
    1,
    2,
    3,
    {
      label: '4+ beds',
      value: 4
    }
  ];

  return (
    <Input {...field.input} type="select" className={styles.madLibControl}>
      {BEDS.map(option => {
        const label = option && option.label ? option.label : option + ' beds';
        const value = option && option.value ? option.value : option;

        return (
          <option key={value} value={value}>
            {label}
          </option>
        );
      })}
    </Input>
  );
};

let BathField = field => {
  const BATHS = [
    {
      label: 'Any Baths',
      value: ''
    },
    1,
    2,
    3,
    {
      label: '4+ baths',
      value: 4
    }
  ];

  return (
    <Input {...field.input} type="select" className={styles.madLibControl}>
      {BATHS.map(option => {
        const label = option && option.label ? option.label : option + ' baths';
        const value = option && option.value ? option.value : option;

        return (
          <option key={value} value={value}>
            {label}
          </option>
        );
      })}
    </Input>
  );
};

let SearchForm = props => {
  const { handleSubmit } = props;

  return (
    <Form inline className={`${BS.flexColumn} ${BS.flexSmRow}`} onSubmit={handleSubmit}>
      <Fields names={['minPrice', 'maxPrice']} component={PriceFields} tabIndex={1} />
      <Input
        plaintext
        className={cx(styles.madLibStaticControl, BS.dNone, BS.dSmBlock)}
      />
      <div className={`${BS.lineBreak} ${BS.mb2}`} />
      <Label for="buildingType">Find me</Label>
      <Field name="buildingType" component={BuildingTypeField} tabIndex={3} />
      <Label for="location">in</Label>
      <Field
        name="location"
        className={styles.location}
        component={LocationField}
        tabIndex={4}
      />
      <div className={`${BS.lineBreak} ${BS.mb2}`} />
      <Label for="numBeds">with</Label>
      <Field name="minBed" component={BedField} tabIndex={5} />
      <Label for="numBaths"> and</Label>
      <Field name="numBaths" component={BathField} tabIndex={6} />
      <Input
        plaintext
        className={cx(styles.madLibStaticControl, BS.dNone, BS.dSmBlock)}
      />
      <div className={`${BS.lineBreak} ${BS.mb2}`} />
      <Button
        color="secondary"
        type="submit"
        className={`${styles.searchSubmit} ${BS.mbSm3}`}
      >
        <MaterialIcon icon="search" />
        Search
      </Button>
    </Form>
  );
};

const FooterSearchForm = reduxForm({
  form: 'footer-search-form'
})(SearchForm);

export default FooterSearchForm;



// WEBPACK FOOTER //
// ./src/containers/App/FooterForm.js